class NavbarMenu {
    constructor() {
      this.menu = document.querySelector(".menu");
      this.menuInner = this.menu.querySelector(".menu__inner");
      this.menuArrow = this.menu.querySelector(".menu__arrow");
      this.menuTitle = this.menu.querySelector(".menu__title");
      this.burger = document.querySelector(".burger");
      this.overlay = document.querySelector(".overlay");
      this.logoImage = document.querySelector(".logo__with__image");
      this.subMenu = null;

      // Initialize event listeners
      this.initEventListeners();
    }

    // Toggle Navbar Menu
    toggleMenu() {
      this.menu.classList.toggle("is-active");
      this.overlay.classList.toggle("is-active");
      document.body.style.overflow = this.overlay.classList.contains("is-active")
      ? "hidden"
      : "";
    }

    // Show Mobile Submenu
    showSubMenu(children) {
      this.subMenu = children.querySelector(".submenu");
      this.logoImage.style.display = 'none';
      this.subMenu.classList.add("is-active");
      this.subMenu.style.animation = "slideLeft 0.35s ease forwards";
      const menuTitleText = children.querySelector("i").parentNode.childNodes[0]
      .textContent;
      this.menu.querySelector(".menu__title").textContent = menuTitleText;
      this.menu.querySelector(".menu__header").classList.add("is-active");
    }

    // Hide Mobile Submenu
    hideSubMenu() {
      if (!this.subMenu) return;
      this.logoImage.style.display = 'flex';
      this.subMenu.style.animation = "slideRight 0.35s ease forwards";
      setTimeout(() => {
        this.subMenu.classList.remove("is-active");
      }, 300);

      this.menu.querySelector(".menu__title").textContent = "";
      this.menu.querySelector(".menu__header").classList.remove("is-active");
    }

    // Toggle Mobile Submenu
    toggleSubMenu(e) {
      if (!this.menu.classList.contains("is-active")) {
        return;
      }
      const menuDropdown = e.target.closest(".menu__dropdown");
      if (menuDropdown) {
        this.showSubMenu(menuDropdown);
      }
    }

    // Initialize Event Listeners
    initEventListeners() {
      this.burger.addEventListener("click", this.toggleMenu.bind(this));
      this.overlay.addEventListener("click", this.toggleMenu.bind(this));
      this.menuArrow.addEventListener("click", this.hideSubMenu.bind(this));
      this.menuTitle.addEventListener("click", this.hideSubMenu.bind(this));
      this.menuInner.addEventListener("click", this.toggleSubMenu.bind(this));

      window.addEventListener("resize", () => {
        if (window.innerWidth >= 768 && this.menu.classList.contains("is-active")) {
          this.toggleMenu();
        }
      });
    }
  }

  // Instantiate NavbarMenu
  const navbarMenu = new NavbarMenu();
